export default "https://cdn-static.gokick.com/assets/faf4ec4796b5499b7477edf17656e3681d9dd642/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";